// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"1b6d84f5","769":"7552c776"}[chunkId] + ".chunk.js";
};